import { Box } from '@mui/material';
import { useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { mainViewWidthState } from '~/state/atoms/toolsAtoms';
import { showFullscreenState } from '~/state/atoms/viewerAtoms';
import OperationsPanelHandler from './OperationsPanelHandler';
import OperationsSection from './OperationsSection';
import PostProcessingSection from './PostProcessingSection';
import SliceOperationsSection from './SliceOperationsSection';

export default function OperationsToolbar() {
    const location = useLocation();
    const isContouringPage = location.pathname.includes('/contouring');
    const mainViewWidth = useRecoilValue(mainViewWidthState);
    const showFullscreen = useRecoilValue(showFullscreenState);
    const toolbarRef = useRef<HTMLElement | null>(null);
    const isReviewPage = location.pathname.includes('/review');

    if (!isContouringPage && !isReviewPage) {
        return null;
    }

    const rightEdgePercent = showFullscreen ? 100 : mainViewWidth;

    return (
        <Box
            ref={toolbarRef}
            sx={(theme) => ({
                position: 'absolute',
                left: `calc(${rightEdgePercent}% - 32px)`,
                top: '50%',
                transform: 'translate(-100%, -50%)',
                zIndex: 800,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 0.5,
                p: 0.5,
                borderRadius: `${theme.shape.borderRadius}px`,
                ...theme.mixins.glassOverlay,
                boxShadow: '0 2px 6px rgba(0, 0, 0, 0.27)',
                border: '1px solid rgba(0, 0, 0, 0.1)',
                pointerEvents: 'auto',
            })}
        >
            {isContouringPage && <OperationsSection />}
            <SliceOperationsSection />
            <PostProcessingSection />
            <OperationsPanelHandler toolbarRef={toolbarRef} />
        </Box>
    );
}
